import { render } from "./DbTablesPage.vue?vue&type=template&id=42a99c70"
import script from "./DbTablesPage.vue?vue&type=script&lang=js"
export * from "./DbTablesPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__